import { uiToggles } from './uiToggles'
import { ads } from './ads'
import { airlines } from './airlines'
import { flags } from './flags'
import { listingsMetaData } from './listingsMetaData'
import { airSearchPromise } from './airSearchPromise'
import { searchSessionKey } from './searchSessionKey/searchSessionKey'
import { hasAppInstalled } from './hasAppInstalled/hasAppInstalled'
import { cheapestPrice } from './cheapestPrice/cheapestPrice'
import { flySearchResponseData } from './flySearchResponseData'
import { employeeDiscount } from './filters/employeeDiscount/employeeDiscount'

import {
  filterInfo,
  airlinesFilter,
  stopsFilter,
  airportsFilter,
  timeFilter,
  attributesFilter,
} from './filters'

import {
  activeTabId,
  listings,
  recommendedListings,
  listingsIsLoading,
  listingsHasErrored,
  displayInfiniteScrollLoadMore,
  listingsLoadingMessage,
  fetchedInitialListings,
  brandReference,
  checkIfNotInitialLoadOfListing,
} from './listings'

import { phoneBookInfo } from './phoneBookInfo'
import { sortOptions } from '@mfs/client/listings-client/reducers/sortOptions/sortOptions'
import { pinnedItins } from '@mfs/client/listings-client/reducers/pinnedItins/pinnedItins'
const listingsApp = () => {
  return {
    pclnBootstrapData: (state) => state || {},
    seti: (state) => state || {},
    airSearchRequestModel: (state) => state || {},
    airSearchPromise: airSearchPromise.reducer,
    flySearchResponseData: flySearchResponseData.reducer,
    // filters
    airlinesFilter: airlinesFilter.reducer,
    stopsFilter: stopsFilter.reducer,
    airportsFilter: airportsFilter.reducer,
    timeFilter: timeFilter.reducer,
    attributesFilter: attributesFilter.reducer,
    filterInfo: filterInfo.reducer,

    uiToggles: uiToggles.reducer,
    ads: ads.reducer,
    airlines: airlines.reducer,
    flags: flags.reducer,

    // listings
    listingsMetaData: listingsMetaData.reducer,
    listings: listings.reducer,
    recommendedListings: recommendedListings.reducer,
    listingsIsLoading: listingsIsLoading.reducer,
    listingsHasErrored: listingsHasErrored.reducer,
    fetchedInitialListings: fetchedInitialListings.reducer,
    checkIfNotInitialLoadOfListing: checkIfNotInitialLoadOfListing.reducer,
    listingsLoadingMessage: listingsLoadingMessage.reducer,
    displayInfiniteScrollLoadMore: displayInfiniteScrollLoadMore.reducer,
    brandReference: brandReference.reducer,

    // SBS Tabs
    activeTabId: activeTabId.reducer,

    phoneBookInfo: phoneBookInfo.reducer,

    searchSessionKey: searchSessionKey.reducer,

    hasAppInstalled: hasAppInstalled.reducer,

    cheapestPrice: cheapestPrice.reducer,

    employeeDiscount: employeeDiscount.reducer,

    sortOptions: sortOptions.reducer,

    pinnedItins: pinnedItins.reducer,
  }
}

export { listingsApp }
